import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from '../../Redux/apiSlice';

const BLOG_LIST_URL = `${API_URL}/blog`;
const BLOG_DELETE_URL = `${API_URL}/blog`;

const BlogList = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    // Read token
    const getAuthHeader = () => {
        try {
            const raw = localStorage.getItem("knighthuntToken") || "";
            const token = raw.trim();
            if (!token) return null;

            return token.toLowerCase().startsWith("bearer ")
                ? token
                : `Bearer ${token}`;
        } catch {
            return null;
        }
    };

    // Fetch blogs
    const fetchBlogs = async () => {
        try {
            setLoading(true);

            const auth = getAuthHeader();

            const resp = await fetch(BLOG_LIST_URL, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    ...(auth ? { Authorization: auth } : {}),
                },
                credentials: "include",
            });

            const data = await resp.json();
            setBlogs(Array.isArray(data?.response) ? data.response : []);
        } catch (err) {
            console.error("Fetch blogs error:", err);
        } finally {
            setLoading(false);
        }
    };

    // Delete a blog
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this blog?")) return;

        try {
            const auth = getAuthHeader();

            const resp = await fetch(`${BLOG_DELETE_URL}/${id}`, {
                method: "DELETE",
                headers: {
                    ...(auth ? { Authorization: auth } : {}),
                },
                credentials: "include",
            });

            const data = await resp.json();

            if (data?.status) {
                alert("Blog deleted successfully!");
                fetchBlogs();
            } else {
                alert(data?.message || "Failed to delete blog.");
            }
        } catch (err) {
            console.error("Delete error:", err);
            alert("Error while deleting blog.");
        }
    };

    useEffect(() => {
        fetchBlogs();
    }, []);

    if (loading) return <p>Loading...</p>;

    return (
        <div className="page-content">
            <h3>Blog List</h3>

            <Link to="/blog-create" className="btn btn-primary mb-3">
                Add Blog
            </Link>

            <table className="table align-middle">
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Slug</th>
                        <th>Excerpt</th>
                        <th>Image</th>
                        <th>Published At</th>
                        <th>Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {blogs.length === 0 ? (
                        <tr>
                            <td colSpan={6} className="text-center text-muted">
                                No blogs found
                            </td>
                        </tr>
                    ) : (
                        blogs.map((blog) => (
                            <tr key={blog.id}>
                                {/* Title */}
                                <td style={{ fontWeight: "600" }}>
                                    {blog.title}
                                </td>

                                {/* Slug */}
                                <td>{blog.slug}</td>

                                {/* Excerpt */}
                                <td style={{ maxWidth: 250 }}>
                                    {blog.excerpt}
                                </td>

                                {/* Image */}
                                <td>
                                    {blog.image ? (
                                        <img
                                            src={blog.image}
                                            alt={blog.title}
                                            style={{
                                                width: 64,
                                                height: 64,
                                                objectFit: "cover",
                                                borderRadius: 6,
                                                border: "1px solid #ddd",
                                            }}
                                        />
                                    ) : (
                                        "-"
                                    )}
                                </td>

                                {/* Published Date */}
                                <td>
                                    {blog.publishedAt
                                        ? new Date(blog.publishedAt).toLocaleString()
                                        : "-"}
                                </td>

                                {/* Actions */}
                                <td>
                                    <Link
                                        to={`/blog-edit/${blog.id}`}
                                        className="btn btn-sm btn-warning me-2"
                                    >
                                        Edit
                                    </Link>

                                    <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => handleDelete(blog.id)}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default BlogList;
